/** User-facing Okta sign-in messages. */

export const OKTA_CANCEL_MESSAGE = 'Okta sign-in was cancelled. You can try again.';

export const OKTA_GENERIC_FAILURE_MESSAGE = 'Okta sign-in failed. Please try again.';

export const OKTA_REJECT_MESSAGE = 'Okta sign-in was rejected. Please try again or contact your administrator.';

export const OKTA_NETWORK_MESSAGE = 'Network error: The server did not respond. Please check your connection and try again.';
